import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "8",
  cy: "14",
  r: "2"
}, "1"), /*#__PURE__*/_jsx("circle", {
  cx: "12",
  cy: "8",
  r: "2"
}, "2"), /*#__PURE__*/_jsx("circle", {
  cx: "16",
  cy: "14",
  r: "2"
}, "3")], 'GroupWorkOutlined');